import EnumService from '../EnumService'

export default class OportunidadeFonteEnumService extends EnumService{

    constructor(){
        super('enumFonteOportunidade');
    }
  
  }